module.exports = __webpack_public_path__ + "img/logo-set.43eedead.svg";